
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Mic } from 'lucide-react';
import { debugLog } from '@/config/debug';

interface MicrophoneErrorDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onRetry?: () => void;
}

export const MicrophoneErrorDialog = ({ 
  open, 
  onOpenChange, 
  onRetry 
}: MicrophoneErrorDialogProps) => {
  const { t } = useTranslation();

  const handleRetry = () => {
    debugLog('DIALOG', '🎤 [DIALOG] Retry button clicked - closing dialog and retrying');
    onOpenChange(false);
    setTimeout(() => {
      onRetry?.();
    }, 100);
  };

  const handleClose = () => {
    debugLog('DIALOG', '🎤 [DIALOG] Close button clicked - closing dialog');
    onOpenChange(false);
  };

  debugLog('DIALOG', '🎤 [DIALOG] Rendering MicrophoneErrorDialog - open:', open);

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="z-[99999] !fixed !top-1/2 !left-1/2 !transform !-translate-x-1/2 !-translate-y-1/2">
        <AlertDialogHeader>
          <div className="flex items-center gap-2">
            <Mic className="w-5 h-5 text-red-500" />
            <AlertDialogTitle>{t('microphone_not_found')}</AlertDialogTitle>
          </div>
          <AlertDialogDescription>
            {t('microphone_not_found_description')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col gap-2 sm:flex-row sm:gap-2 sm:justify-end">
          <AlertDialogCancel onClick={handleClose} className="w-full sm:w-auto">
            {t('close')}
          </AlertDialogCancel>
          <AlertDialogAction onClick={handleRetry} className="w-full sm:w-auto">
            {t('try_again')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
